import { AddCartNonPricedProductFormProvider } from "./AddCartNonPricedProductFormProvider";
import { NameFormInput, PriceFormInput } from "./components";

export interface AddCartNonPricedProductFormProps {}

export const AddCartNonPricedProductForm =
  ({}: AddCartNonPricedProductFormProps) => {
    return null;
  };

AddCartNonPricedProductForm.Provider = AddCartNonPricedProductFormProvider;
AddCartNonPricedProductForm.NameFormInput = NameFormInput;
AddCartNonPricedProductForm.PriceFormInput = PriceFormInput;
